import type { FaireProductEntity } from "../../entity_types/product";

export const p_96up7pbk2u: FaireProductEntity = {
  token: "p_96up7pbk2u",
  type: "product",
  name: "Oaxacan Spice Cacao - Organic Ceremonial Chocolate",
  brandToken: "b_djuc44eyt2",
  brandName: "Ora Cacao",
  imageUrl:
    "https://cdn.faire.com/fastly/66ea125ef1b609448d665476b348b0f4bab2b6be8f1e8ba0ec5410180a8a0c25.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e21254a7dd0ceb5d4455a4ed4eb71ca7506e62f11809a731869e0ad0fd3b4fa0.png",
    "https://cdn.faire.com/fastly/1f747abb235ee5e0715737b342f0dbf39252528a60e39453e42c7a02edc40e90.png",
    "https://cdn.faire.com/fastly/852d58e63db3e3193167564ddefe7f3382a2787b8edb6515d8ff62f93fb9b26b.jpeg",
    "https://cdn.faire.com/fastly/064b94bd5eebe080422e6cf3161eab913ac1ddb843f17e65b665820a859e8621.png",
    "https://cdn.faire.com/fastly/27a2a10909a26d56b4bf54c505cbbc8fa070fab794b3797761c400e747b8cd48.png",
    "https://cdn.faire.com/fastly/3a1f53cf299cc74a353113c4f6d34a642ff00177af8d9b32d39983695696f6ff.jpeg",
  ],
  priceDollars: 18.6,
  description:
    "On some days you just need a little extra celebration and motivation, and this pure ceremonial cacao elevates you quickly as our blend of cinnamon, cardamom, ginger, and cayenne get your circulation pulsing.\n\nAncient peoples of central & South America loved drinking their chocolate hot and spicy rather than sugary. This is a modern interpretation of ancient Mayan drinking chocolate honoring our Zapotec elder Maria, who taught us the time-honored ways of chocolate making in Oaxaca. Through this enhanced cacao, we connect to the roots of ceremonial cacao with gratitude.\n\n𝐎𝐫𝐠𝐚𝐧𝐢𝐜 𝐈𝐧𝐠𝐫𝐞𝐝𝐢𝐞𝐧𝐭𝐬:\nCacao Beans, Cinnamon from Sri Lanka, Cardamom from Guatemala, Ginger from China, Cayenne from India\n\n• Makes a great coffee replacement!\n• For dark chocolate lovers.\n• Lab tested for heavy metals safety.\n• High flavanol / flavonoid.",
  tags: [],
  msrpDollars: 31,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-30T01:35:40.322Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
